"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ClearFiltersIcon = function () {
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "29.751", height: "30", viewBox: "0 0 29.751 30" },
        react_1.default.createElement("g", { transform: "translate(-1493.999 -141.25)" },
            react_1.default.createElement("path", { d: "M3863.615-3209.75a1.591,1.591,0,0,1-1.06-.4L3859.3-3213a1.853,1.853,0,0,1-.555-1.223v-9.483l-9.272-9.274a1.6,1.6,0,0,1-.35-1.77,1.6,1.6,0,0,1,1.5-1H3862a9.466,9.466,0,0,0-.634,1.625h-10.743l9.75,9.75v10.156l3.25,2.843v-13l.284-.283a9.568,9.568,0,0,0,1.341,1.077v12.205A1.614,1.614,0,0,1,3863.615-3209.75Z", transform: "translate(-2355 3381)", fill: "#008272" }),
            react_1.default.createElement("path", { d: "M8-13.75A7.749,7.749,0,0,0,.25-6,7.749,7.749,0,0,0,8,1.75,7.749,7.749,0,0,0,15.75-6,7.749,7.749,0,0,0,8-13.75Zm0,14A6.248,6.248,0,0,1,1.75-6,6.248,6.248,0,0,1,8-12.25,6.248,6.248,0,0,1,14.25-6,6.248,6.248,0,0,1,8,.25Zm3.181-8.194a.375.375,0,0,0,0-.531l-.706-.706a.375.375,0,0,0-.531,0L8-7.237,6.056-9.181a.375.375,0,0,0-.531,0l-.706.706a.375.375,0,0,0,0,.531L6.762-6,4.819-4.056a.375.375,0,0,0,0,.531l.706.706a.375.375,0,0,0,.531,0L8-4.763,9.944-2.819a.375.375,0,0,0,.531,0l.706-.706a.375.375,0,0,0,0-.531L9.237-6Z", transform: "translate(1508 155)", fill: "#fd5d7c" }))));
};
exports.default = react_1.memo(ClearFiltersIcon);
